"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactAlreadyExistsError = exports.ContactDoesNotExistError = exports.ContactBodyNotValidError = void 0;
const TutoringServiceClient_1 = __importDefault(require("./TutoringServiceClient"));
exports.default = TutoringServiceClient_1.default;
var ContactBodyNotValidError_1 = require("./errors/ContactBodyNotValidError");
Object.defineProperty(exports, "ContactBodyNotValidError", { enumerable: true, get: function () { return __importDefault(ContactBodyNotValidError_1).default; } });
var ContactDoesNotExistError_1 = require("./errors/ContactDoesNotExistError");
Object.defineProperty(exports, "ContactDoesNotExistError", { enumerable: true, get: function () { return __importDefault(ContactDoesNotExistError_1).default; } });
var ContactAlreadyExistsError_1 = require("./errors/ContactAlreadyExistsError");
Object.defineProperty(exports, "ContactAlreadyExistsError", { enumerable: true, get: function () { return __importDefault(ContactAlreadyExistsError_1).default; } });
//# sourceMappingURL=index.js.map